import React from 'react';
import { Link } from 'react-router-dom';

const link = (props) => {
    return (
        <li>
            <Link to={props.link} >
                {props.children}
            </Link>
        </li>
    )
};

export default link;


// WEBPACK FOOTER //
// ./src/Components/Footer/FooterLink/FooterLink.js